/* eslint-disable indent */
//import Nav from 'react-bootstrap/Nav'
import { specArray } from '../services/arrays'

const PlayerOnTransfer = ({ player }) => {
  const tyhja = 0
  const vali = ' '
  return (
    <tr align="center">
      <td>
        <a
          href={`https://hattrick.org/goto.ashx?path=/Club/Players/Player.aspx?playerId=${player.PlayerId}`}
          target="_blank"
          rel="noreferrer"
        >
          <div>
            {player.FirstName}
            {vali}
            {player.LastName}
          </div>
        </a>
      </td>
      <td>{player.decimal}</td>
      <td>
        {player.HighestBid !== '0'
          ? (Number(player.HighestBid) / 10).toLocaleString('fi-FI', {
              useGrouping: true,
            })
          : '(' +
            (Number(player.AskingPrice) / 10).toLocaleString('fi-FI', {
              useGrouping: true,
            }) +
            ')'}
      </td>
      <td>
        {player.Details.Age}.{player.Details.AgeDays}
      </td>
      <td>{specArray[Number(player.Details.Specialty)]}</td>
      <td>{player.Details.KeeperSkill || tyhja}</td>
      <td>{player.Details.DefenderSkill || tyhja}</td>
      <td>{player.Details.PlaymakerSkill || tyhja}</td>
      <td>{player.Details.WingerSkill || tyhja}</td>
      <td>{player.Details.PassingSkill || tyhja}</td>
      <td>{player.Details.ScorerSkill || tyhja}</td>
      <td>{player.Details.SetPiecesSkill || tyhja}</td>
    </tr>
  )
}

export default PlayerOnTransfer
